var _path, _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderBgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 720,
    viewBox: "0 0 1440 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M720.5 120C175 120 240.2 40 0 0V720C240.2 680 175 600 720.5 600C1266 600 1200.8 680 1441 720V0C1200.8 40 1266 120 720.5 120Z",
    fill: "url(#paint0_linear_29_121)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.6 259.3C174 260.4 172.2 261.7 170.1 263.3C158.9 271.5 120.7 298.2 80.5 299C88.1 301 96 302 104.2 302C126 302 146 294.5 161.9 282C168.1 275 172.5 267.3 175.6 259.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M178.4 265.2C180.9 261.9 183.2 258.4 185.3 254.8C184.7 254.5 183.8 254.6 182.3 255.2C181.1 258.7 179.9 262 178.4 265.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M186.4 232.4C186 238.2 185.2 244 183.8 249.6C185.4 249.3 186.8 249.3 187.9 249.8C192.5 240.4 195.6 230.2 196.8 219.4C193.2 225 190.2 229.2 186.4 232.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M184.4 204.9C185.7 211.6 186.5 218.4 186.5 225.2C191.2 221.6 194.9 217.3 197.3 212C197.3 211 197.4 209.9 197.4 208.9C197.4 199.9 196.1 191.3 193.8 183.1C192.5 190.7 190.2 199 184.4 204.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M183 198.6C188.6 193.9 191.2 184.1 189.1 170.3C174.5 138 142 115.5 104.2 115.5C102 115.5 99.8001 115.6 97.6001 115.8C140.4 122.3 172.7 158.2 183 198.6Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.1 180.9C145.5 203.5 158.8 208.1 177 201.7C162.9 144.2 112.3 117.4 77.8001 119.4C57.0001 125.5 39.2 138.7 27.3 156.2C43.5 152.6 57.6001 157.2 104.1 180.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.8 289.8C115.4 287 158.9 262.7 164.5 259.9C167 258.6 172.6 254.5 178 251.8C179.3 246.9 180.1 241.8 180.5 236.6C173.3 240.6 162.8 243.5 144.2 247.5C117.1 255.1 60 263.6 12 222.6C16.4 252.5 35.1 277.8 60.9 291.3C79.9 295.3 86.1 294.6 105.8 289.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M141.3 241.8C155.8 238.5 169.9 235 180.6 229C180.5 224.9 180.3 220.7 179.7 216.4C179.4 214 179 211.6 178.6 209.2C169.9 213.9 156.2 214.6 134.5 206.8C111.9 196.1 60.5 161.6 38.5 161.6C33.9 161.6 29.9 160.1 23.9 161.3C15.7 175.2 10.9 191.4 10.9 208.7C10.9 211 11 213.2 11.2 215.4C29.3 235 85.5 257.4 141.3 241.8Z",
    fill: "#1C2624"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.2 440.3C404 441.1 402.7 442.1 401.1 443.3C392.7 449.4 364.4 469.2 334.6 469.8C340.2 471.3 346.1 472.1 352.2 472.1C368.4 472.1 383.3 466.5 395 457.2C399.6 451.9 402.9 446.3 405.2 440.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M407.3 444.7C409.2 442.3 410.9 439.7 412.4 437C412 436.8 411.3 436.8 410.2 437.3C409.3 439.8 408.4 442.3 407.3 444.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M413.2 420.4C412.9 424.7 412.3 429 411.3 433.2C412.5 433 413.5 433 414.3 433.4C417.7 426.4 420 418.8 420.9 410.8C418.3 414.9 416 417.9 413.2 420.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M411.8 399.9C412.8 404.9 413.3 409.9 413.4 415C416.9 412.3 419.7 409.1 421.4 405.2C421.4 404.4 421.5 403.7 421.5 402.9C421.5 396.2 420.5 389.8 418.8 383.7C417.8 389.4 416 395.5 411.8 399.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M410.7 395.3C414.9 391.8 416.8 384.5 415.2 374.3C404.3 350.3 380.2 333.6 352.1 333.6C350.5 333.6 348.8 333.7 347.2 333.8C379.1 338.6 403 365.3 410.7 395.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M352.1 382.1C382.9 398.9 392.7 402.3 406.2 397.5C395.7 354.8 358.2 334.9 332.6 336.4C317.2 341 304 350.7 295.1 363.7C307.1 361.1 317.6 364.5 352.1 382.1Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M353.4 463C360.5 460.9 392.8 442.9 397 440.8C398.9 439.9 403 436.8 407 434.8C408 431.1 408.6 427.4 408.8 423.5C403.4 426.5 395.7 428.6 381.9 431.6C361.8 437.2 319.4 443.6 283.8 413.1C287.1 435.3 301 454.1 320.1 464.1C334.2 467.1 338.8 466.5 353.4 463Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M379.8 427.3C390.6 424.9 401 422.2 409 417.8C409 414.7 408.7 411.6 408.3 408.5C408.1 406.7 407.8 404.9 407.5 403.2C401 406.7 390.9 407.2 374.8 401.4C358 393.4 319.9 367.9 303.5 367.9C300.1 367.9 297.1 366.8 292.6 367.7C286.5 378 283 390 283 402.9C283 404.6 283.1 406.2 283.2 407.9C296.6 422.2 338.3 438.9 379.8 427.3Z",
    fill: "#1C2624"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1404.1 366.5C1402.5 369 1400.7 371.9 1398.7 375.3C1387.5 393.4 1349 453.4 1292.4 477.8C1304.3 476.2 1316.1 473.1 1327.7 468.4C1358.6 455.8 1382.6 433.5 1397.8 406.6C1402.5 393 1404.5 379.7 1404.1 366.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1411.5 373.3C1413.1 367.2 1414.4 361 1415.2 354.6C1414.2 354.5 1412.9 355.1 1411.2 356.9C1411.6 362.4 1411.7 367.8 1411.5 373.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1403.9 322.2C1406.8 330.6 1408.9 339.3 1410.2 348.1C1412.2 346.7 1414.3 346 1416.1 346.1C1417.2 330.2 1415.6 313.9 1411.1 297.8C1409.1 307.7 1407.3 315.3 1403.9 322.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1385.1 284.2C1390.9 292.9 1395.9 302.1 1399.9 311.7C1404.5 303.9 1407.2 295.6 1407.5 286.7C1407 285.2 1406.4 283.7 1405.8 282.2C1400.6 269.5 1393.8 258 1385.7 247.7C1388.4 259.4 1389.8 272.6 1385.1 284.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1379.5 276.2C1384.8 266.3 1382.7 250.8 1371.7 232.6C1332.2 195.3 1273.1 182.3 1219.6 204.2C1216.5 205.5 1213.4 206.9 1210.4 208.4C1274.8 192.8 1341.4 225 1379.5 276.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1257.3 296.8C1329.1 304.8 1350.5 303.7 1372.7 284C1319.4 210.7 1232.2 202 1184.5 224.9C1158.6 245.6 1141.1 274.6 1134.2 306.3C1155 291.9 1177.7 290.2 1257.3 296.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1322.9 450.2C1334.9 440.6 1382.4 381 1388.8 373.8C1391.6 370.6 1397.2 361.5 1403.2 354.5C1402.2 346.7 1400.4 339.1 1397.9 331.5C1390 341.4 1376.8 351.5 1352.8 367.9C1318.9 394.3 1242.9 439.6 1151.2 409.2C1174.8 449 1215.9 474 1260.3 478.2C1289.4 473 1297.9 468.4 1322.9 450.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1345.5 361.6C1364.2 348.6 1382 335.3 1393.8 320.6C1391.3 314.8 1388.5 309 1385.2 303.3C1383.4 300 1381.4 296.9 1379.5 293.8C1369.9 305.6 1350.8 314.4 1315.7 315.9C1277.5 313.8 1184.7 294.8 1153.5 307.5C1147 310.2 1140.4 310.3 1132.6 315.6C1129 340 1131.7 365.7 1141.7 390.3C1143 393.5 1144.5 396.6 1146 399.7C1182.7 416.8 1275.4 416.1 1345.5 361.6Z",
    fill: "#1C2624"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1141.8 578.3C1141.2 579.2 1140.6 580.2 1139.9 581.4C1136 587.8 1122.4 608.8 1102.6 617.4C1106.8 616.8 1110.9 615.8 1115 614.1C1125.8 609.7 1134.3 601.8 1139.6 592.4C1141.2 587.6 1141.9 582.9 1141.8 578.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1144.4 580.7C1145 578.6 1145.4 576.4 1145.7 574.1C1145.3 574.1 1144.9 574.3 1144.3 574.9C1144.4 576.8 1144.5 578.7 1144.4 580.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1141.7 562.7C1142.7 565.7 1143.5 568.7 1143.9 571.8C1144.6 571.3 1145.3 571 1146 571.1C1146.4 565.5 1145.8 559.8 1144.2 554.1C1143.6 557.6 1142.9 560.3 1141.7 562.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1135.1 549.4C1137.1 552.5 1138.9 555.7 1140.3 559.1C1141.9 556.4 1142.9 553.4 1143 550.3C1142.8 549.8 1142.6 549.3 1142.4 548.7C1140.6 544.2 1138.2 540.2 1135.3 536.6C1136.3 540.7 1136.8 545.3 1135.1 549.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1133.1 546.6C1135 543.1 1134.2 537.7 1130.4 531.3C1116.5 518.2 1095.8 513.6 1077 521.3C1075.9 521.8 1074.8 522.3 1073.8 522.8C1096.4 517.2 1119.7 528.6 1133.1 546.6Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1090.2 553.8C1115.4 556.6 1123 556.2 1130.7 549.3C1112 523.6 1081.3 520.5 1064.6 528.6C1055.5 535.9 1049.3 546.1 1046.9 557.2C1054.3 552.1 1062.2 551.5 1090.2 553.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1113.2 607.7C1117.4 604.3 1134.1 583.4 1136.3 580.8C1137.3 579.7 1139.2 576.5 1141.4 574C1141 571.3 1140.4 568.6 1139.5 565.9C1136.7 569.4 1132.1 572.9 1123.7 578.7C1111.8 588 1085.1 603.9 1052.9 593.2C1061.2 607.2 1075.6 616 1091.2 617.5C1101.5 615.7 1104.5 614.1 1113.2 607.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1121.2 576.6C1127.8 572 1134 567.4 1138.2 562.2C1137.3 560.1 1136.3 558.1 1135.2 556.1C1134.6 554.9 1133.9 553.8 1133.2 552.8C1129.8 556.9 1123.1 560 1110.8 560.6C1097.4 559.9 1064.8 553.2 1053.8 557.7C1051.5 558.6 1049.2 558.7 1046.5 560.5C1045.2 569.1 1046.2 578.1 1049.7 586.7C1050.2 587.8 1050.7 588.9 1051.2 590C1064 596 1096.6 595.7 1121.2 576.6Z",
    fill: "#1C2624"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1076.9 198.2C1076.1 199.4 1075.3 200.8 1074.3 202.5C1068.9 211.3 1050.1 240.5 1022.6 252.3C1028.4 251.5 1034.1 250 1039.8 247.7C1054.8 241.6 1066.5 230.7 1073.9 217.6C1076.1 211.1 1077.1 204.6 1076.9 198.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1080.5 201.5C1081.3 198.5 1081.9 195.5 1082.3 192.4C1081.8 192.4 1081.2 192.7 1080.3 193.5C1080.6 196.2 1080.6 198.9 1080.5 201.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1076.8 176.7C1078.2 180.8 1079.2 185 1079.9 189.3C1080.9 188.6 1081.9 188.3 1082.8 188.3C1083.3 180.5 1082.6 172.6 1080.4 164.8C1079.4 169.6 1078.5 173.3 1076.8 176.7Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1067.7 158.2C1070.5 162.5 1072.9 166.9 1074.9 171.6C1077.1 167.8 1078.5 163.8 1078.6 159.4C1078.3 158.7 1078.1 158 1077.8 157.2C1075.3 151 1071.9 145.4 1068 140.4C1069.3 146.2 1070 152.5 1067.7 158.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1065 154.3C1067.6 149.5 1066.6 142 1061.2 133.1C1042 115 1013.3 108.6 987.2 119.3C985.7 119.9 984.2 120.6 982.7 121.3C1014.1 113.7 1046.4 129.4 1065 154.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1005.5 164.3C1040.4 168.2 1050.8 167.7 1061.6 158.1C1035.7 122.5 993.3 118.2 970.1 129.4C957.5 139.5 949 153.6 945.6 169C955.8 161.9 966.8 161.1 1005.5 164.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1037.4 238.9C1043.2 234.2 1066.3 205.3 1069.4 201.7C1070.8 200.1 1073.5 195.7 1076.4 192.3C1075.9 188.5 1075 184.8 1073.8 181.1C1070 185.9 1063.5 190.8 1051.9 198.8C1035.4 211.6 998.4 233.7 953.8 218.9C965.3 238.3 985.3 250.4 1006.9 252.5C1021.2 250 1025.3 247.8 1037.4 238.9Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M1048.4 195.8C1057.5 189.5 1066.2 183 1071.9 175.9C1070.7 173.1 1069.3 170.3 1067.7 167.5C1066.8 165.9 1065.9 164.4 1064.9 162.9C1060.2 168.6 1051 172.9 1033.8 173.6C1015.2 172.6 970.1 163.3 954.9 169.5C951.7 170.8 948.5 170.9 944.7 173.4C943 185.3 944.3 197.8 949.1 209.7C949.7 211.3 950.4 212.8 951.2 214.2C969.3 222.7 1014.3 222.3 1048.4 195.8Z",
    fill: "#1C2624"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M189.2 602.2C188.3 602.8 187.3 603.5 186.2 604.4C179.9 609 158.7 623.9 136.2 624.3C140.4 625.4 144.9 626 149.4 626C161.6 626 172.7 621.8 181.6 614.8C185 610.9 187.5 606.7 189.2 602.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M190.8 605.5C192.2 603.7 193.5 601.7 194.6 599.7C194.3 599.5 193.8 599.6 192.9 599.9C192.3 601.8 191.6 603.7 190.8 605.5Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M195.3 587.2C195.1 590.4 194.6 593.7 193.9 596.8C194.8 596.6 195.6 596.6 196.2 596.9C198.8 591.7 200.5 586 201.2 579.9C199.1 583.1 197.4 585.4 195.3 587.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M194.2 571.8C194.9 575.5 195.4 579.3 195.4 583.1C198 581.1 200.1 578.7 201.4 575.7C201.4 575.1 201.4 574.5 201.4 574C201.4 569 200.7 564.2 199.4 559.6C198.7 563.9 197.4 568.5 194.2 571.8Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M193.4 568.3C196.5 565.7 198 560.2 196.8 552.5C188.6 534.5 170.5 521.9 149.4 521.9C148.2 521.9 146.9 522 145.7 522C169.6 525.8 187.6 545.8 193.4 568.3Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.3 558.4C172.4 571 179.8 573.6 190 570C182.1 537.9 153.9 523 134.7 524.1C123.1 527.5 113.2 534.9 106.5 544.6C115.5 542.7 123.4 545.2 149.3 558.4Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.3 619.2C155.7 617.6 179.9 604.1 183.1 602.5C184.5 601.8 187.6 599.5 190.6 598C191.3 595.2 191.8 592.4 192 589.5C188 591.7 182.1 593.3 171.8 595.6C156.7 599.8 124.8 604.6 98.1001 581.7C100.6 598.4 111 612.5 125.4 620C135.9 622.3 139.3 621.9 150.3 619.2Z",
    fill: "#1C2624"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.1 592.5C178.2 590.7 186 588.7 192 585.3C192 583 191.8 580.7 191.5 578.3C191.3 576.9 191.1 575.6 190.9 574.3C186 576.9 178.4 577.3 166.3 572.9C153.7 566.9 125 547.7 112.7 547.7C110.1 547.7 107.9 546.8 104.5 547.5C99.9 555.2 97.3 564.3 97.3 573.9C97.3 575.2 97.4 576.4 97.4 577.6C107.6 588.6 139 601.1 170.1 592.5Z",
    fill: "#1C2624"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_121",
    x1: 180.25,
    y1: 900.25,
    x2: 1260.75,
    y2: -180.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9E63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9082A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderBgDesktop);
export default __webpack_public_path__ + "static/media/header-bg-desktop.5963cd9770791a9825e5fdcd7853c76b.svg";
export { ForwardRef as ReactComponent };